'use client';

import {styled} from "@mui/system";
import {Box, BoxProps} from "@mui/material";

const MetricsItem = styled(({...props }: BoxProps) => (
    <Box {...props} />
))(({ theme }) => ({
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    fontSize: '1rem',
    ' .icon' : {
        color: theme.palette.primary.main,
        marginRight: '.3rem',
        verticalAlign: 'text-bottom',
        width: '1rem',
        height: '1rem',
    }
}));

export default MetricsItem;
